"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var acceptedPropsStart = 'data-';
exports.filterDataProps = function (props) {
    var output = {};
    for (var key in props) {
        if (props.hasOwnProperty(key) &&
            key.length > acceptedPropsStart.length &&
            key.startsWith(acceptedPropsStart)) {
            output[key] = props[key];
        }
    }
    return output;
};
//# sourceMappingURL=filter-data-props.js.map